module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "uil-squares",
    staticStyle: {
      "margin": "3rem auto",
      "display": "block"
    },
    attrs: {
      "width": "100px",
      "height": "100px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('rect', {
    staticClass: "bk",
    attrs: {
      "x": "0",
      "y": "0",
      "width": "100",
      "height": "100",
      "fill": "none"
    }
  }), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "15",
      "y": "15",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.0s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "40",
      "y": "15",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.125s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "65",
      "y": "15",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.25s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "15",
      "y": "40",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.875s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "65",
      "y": "40",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.375",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "15",
      "y": "65",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.75s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "40",
      "y": "65",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.625s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })]), _c('rect', {
    staticClass: "sq",
    attrs: {
      "x": "65",
      "y": "65",
      "width": "20",
      "height": "20",
      "fill": "#577f40"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill",
      "from": "#577f40",
      "to": "#a7f57a",
      "repeatCount": "indefinite",
      "dur": "1s",
      "begin": "0.5s",
      "values": "#a7f57a;#a7f57a;#577f40;#577f40",
      "keyTimes": "0;0.1;0.2;1"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e6ece5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/loading.vue
// module id = 170
// module chunks = 4